import { ColorSwatch, OverflowText } from "@transfr-inc/dashboard-components";

import "./tag.item.scss";

export const TagItem = ({ value, children }) => {
  return (
    <div className="tag-item">
      {value?.color && <ColorSwatch color={value?.color} />}
      <div className="tag-item-name">
        <OverflowText text={value?.value}>{value?.value}</OverflowText>
      </div>
      {children}
    </div>
  );
};
